import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ResultFinal() {
  return (
    <section className="result_nurs p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="m-auto">
            <h2>
              The <span style={{ color: "#6D4FC1" }}>Results</span>
            </h2>
            <p>
              The Nurse Practitioners application is one of a kind digital
              solution that aids the healthcare and medical sector in an
              authoritative way, solving a problem that has been critical. Now,
              it is easy for everyone to install the application and request
              nursing services at their doorstep without having to call anyone
              or go through a tedious process.
            </p>
            <p>
              TekRevol went the extra mile to develop this application and
              ensure its top quality because of the significance of the industry
              and high stakes. We overcame all the challenges to produce a
              seamless mobile and web app that not only serves the purpose but
              delivers long-term value
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center my-auto offset-xl-1"
          >
            <StaticImage
              src="../../../images/case-studies/nurse-practition/tek_img_07.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={745}
              height={695}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ResultFinal;
